import React, { lazy, Suspense, useEffect, useRef } from 'react';
import { useParams, Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const serverConfig = require("../../config/server.js");

// Lazy load the SNL components for better performance
const Snl100562 = lazy(() => import('./100562_Tri_Counties_Bank.jsx'));
const Snl1008674 = lazy(() => import('./1008674_Reading_Co_Operative_Bank.jsx'));
const Snl114840 = lazy(() => import('./114840_First_State_Bank.jsx'));
const Snl1162017 = lazy(() => import('./1162017_United_Security_Bank.jsx'));
const Snl121642 = lazy(() => import('./121642_BankPlus.jsx'));
const Snl130541 = lazy(() => import('./130541_Horizon_Bank.jsx'));
const Snl137447 = lazy(() => import('./137447_FIRST_NATIONAL_BANK.jsx'));
const Snl1459799 = lazy(() => import('./1459799_First_Peoples_Bank.jsx'));
const Snl151957 = lazy(() => import('./151957_Flatwater_Bank.jsx'));
const Snl159636 = lazy(() => import('./159636_Wilson_Bank___Trust.jsx'));
const Snl161602 = lazy(() => import('./161602_The_Canandaigua_National_Bank_and_Trust_.jsx'));
const Snl1864197 = lazy(() => import('./1864197_Oak_Valley_Community_Bank.jsx'));
const Snl1883321 = lazy(() => import('./1883321_FIRST_AMERICAN_TRUST.jsx'));
const Snl1918344 = lazy(() => import('./1918344_Preferred_Bank.jsx'));
const Snl1929247 = lazy(() => import('./1929247_SouthState_Bank__National_Association.jsx'));
const Snl208244 = lazy(() => import('./208244_Old_National_Bank.jsx'));
const Snl2209553 = lazy(() => import('./2209553_Heritage_Bank_of_Commerce.jsx'));
const Snl2652092 = lazy(() => import('./2652092_EagleBank.jsx'));
const Snl2734729 = lazy(() => import('./2734729_American_Business_Bank.jsx'));
const Snl2743244 = lazy(() => import('./2743244_Red_River_Bank.jsx'));
const Snl278818 = lazy(() => import('./278818_Peoples_Security_Bank_and_Trust_Company.jsx'));
const Snl294779 = lazy(() => import('./294779_Timberland_Bank.jsx'));
const Snl297761 = lazy(() => import('./297761_Monterey_County_Bank.jsx'));
const Snl309655 = lazy(() => import('./309655_Regent_Bank.jsx'));
const Snl3212402 = lazy(() => import('./3212402_PACIFIC_CITY_BANK.jsx'));
const Snl3213333 = lazy(() => import('./3213333_Community_Bank_of_Georgia.jsx'));
const Snl3232204 = lazy(() => import('./3232204_Poppy_Bank.jsx'));
const Snl3235410 = lazy(() => import('./3235410_SANTA_CRUZ_COUNTY_BANK.jsx'));
const Snl3271799 = lazy(() => import('./3271799_Meridian_Bank.jsx'));
const Snl3281510 = lazy(() => import('./3281510_Beach_Cities_Commercial_Bank.jsx'));
const Snl3357219 = lazy(() => import('./3357219_Open_Bank.jsx'));
const Snl3357385 = lazy(() => import('./3357385_Bank_of_San_Francisco.jsx'));
const Snl3394380 = lazy(() => import('./3394380_California_International_Bank__N_A_.jsx'));
const Snl34537 = lazy(() => import('./34537_Seacoast_National_Bank.jsx'));
const Snl3545258 = lazy(() => import('./3545258_CalPrivate_Bank.jsx'));
const Snl3567269 = lazy(() => import('./3567269_Select_Bank.jsx'));
const Snl3835454 = lazy(() => import('./3835454_Royal_Business_Bank.jsx'));
const Snl403067 = lazy(() => import('./403067_Beacon_Business_Bank__National_Associati.jsx'));
const Snl41825 = lazy(() => import('./41825_Middletown_Valley_Bank.jsx'));
const Snl423739 = lazy(() => import('./423739_Morris_Bank.jsx'));
const Snl431172 = lazy(() => import('./431172_RSSD_431172.jsx'));
const Snl507068 = lazy(() => import('./507068_Exchange_Bank__Santa_Rosa__CA_.jsx'));
const Snl519360 = lazy(() => import('./519360_Mission_National_Bank.jsx'));
const Snl535753 = lazy(() => import('./535753_Academy_Bank__N_A_.jsx'));
const Snl537560 = lazy(() => import('./537560_Extraco_Banks__National_Association.jsx'));
const Snl54973 = lazy(() => import('./54973_American_Savings_Bank__F_S_B_.jsx'));
const Snl573036 = lazy(() => import('./573036_Oconee_State_Bank.jsx'));
const Snl584724 = lazy(() => import('./584724_CITIZENS_SAVINGS_BANK.jsx'));
const Snl587800 = lazy(() => import('./587800_Liberty_Bank.jsx'));
const Snl60143 = lazy(() => import('./60143_Comerica_Bank.jsx'));
const Snl63069 = lazy(() => import('./63069_City_National_Bank.jsx'));
const Snl65205 = lazy(() => import('./65205_The_Torrington_Savings_Bank.jsx'));
const Snl662369 = lazy(() => import('./662369_Bank_of_the_Sierra.jsx'));
const Snl663245 = lazy(() => import('./663245_Simmons_Bank.jsx'));
const Snl667757 = lazy(() => import('./667757_Origin_Bank.jsx'));
const Snl672537 = lazy(() => import('./672537_The_Exchange_Bank_of_Alabama.jsx'));
const Snl682563 = lazy(() => import('./682563_Frost_Bank.jsx'));
const Snl698144 = lazy(() => import('./698144_Community_Financial_Services_Bank.jsx'));
const Snl703767 = lazy(() => import('./703767_Community_West_Bank.jsx'));
const Snl739560 = lazy(() => import('./739560_Fremont_Bank.jsx'));
const Snl764030 = lazy(() => import('./764030_Ameris_Bank.jsx'));
const Snl773470 = lazy(() => import('./773470_Malaga_Bank__FSB.jsx'));
const Snl777366 = lazy(() => import('./777366_Bank_of_the_Orient.jsx'));
const Snl780263 = lazy(() => import('./780263_Ozona_Bank.jsx'));
const Snl808260 = lazy(() => import('./808260_Farmers___Merchants_Bank_of_Central_Cali.jsx'));
const Snl814074 = lazy(() => import('./814074_First_Federal_Bank__A_FSB.jsx'));
const Snl836843 = lazy(() => import('./836843_MidWestOne_Bank.jsx'));
const Snl839255 = lazy(() => import('./839255_FNB_Community_Bank.jsx'));
const Snl845573 = lazy(() => import('./845573_Spencer_Savings_Bank__Savings_and_Loan_A.jsx'));
const Snl856243 = lazy(() => import('./856243_FIRST_NATIONAL_BANK_OF_OTTAWA.jsx'));
const Snl86675 = lazy(() => import('./86675_ROSEDALE_FEDERAL_SAVINGS_AND_LOAN_ASSOCI.jsx'));
const Snl871769 = lazy(() => import('./871769_Farmers___Merchants_Bank_of_Long_Beach.jsx'));
const Snl874845 = lazy(() => import('./874845_Lake_City_Bank.jsx'));
const Snl881478 = lazy(() => import('./881478_Heritage_Bank.jsx'));
const Snl884303 = lazy(() => import('./884303_Chemung_Canal_Trust_Company.jsx'));
const Snl901358 = lazy(() => import('./901358_Heritage_Bank__National_Association.jsx'));
const Snl933966 = lazy(() => import('./933966_Citizens_Business_Bank.jsx'));
const Snl936462 = lazy(() => import('./936462_Mechanics_Bank.jsx'));
const Snl961576 = lazy(() => import('./961576_El_Dorado_Savings_Bank__F_S_B_.jsx'));
const Snl996260 = lazy(() => import('./996260_CTBC_Bank_Corp___USA_.jsx'));

const snlComponents = {
    '100562': Snl100562,
    '1008674': Snl1008674,
    '114840': Snl114840,
    '1162017': Snl1162017,
    '121642': Snl121642,
    '130541': Snl130541,
    '137447': Snl137447,
    '1459799': Snl1459799,
    '151957': Snl151957,
    '159636': Snl159636,
    '161602': Snl161602,
    '1864197': Snl1864197,
    '1883321': Snl1883321,
    '1918344': Snl1918344,
    '1929247': Snl1929247,
    '208244': Snl208244,
    '2209553': Snl2209553,
    '2652092': Snl2652092,
    '2734729': Snl2734729,
    '2743244': Snl2743244,
    '278818': Snl278818,
    '294779': Snl294779,
    '297761': Snl297761,
    '309655': Snl309655,
    '3212402': Snl3212402,
    '3213333': Snl3213333,
    '3232204': Snl3232204,
    '3235410': Snl3235410,
    '3271799': Snl3271799,
    '3281510': Snl3281510,
    '3357219': Snl3357219,
    '3357385': Snl3357385,
    '3394380': Snl3394380,
    '34537': Snl34537,
    '3545258': Snl3545258,
    '3567269': Snl3567269,
    '3835454': Snl3835454,
    '403067': Snl403067,
    '41825': Snl41825,
    '423739': Snl423739,
    '431172': Snl431172,
    '507068': Snl507068,
    '519360': Snl519360,
    '535753': Snl535753,
    '537560': Snl537560,
    '54973': Snl54973,
    '573036': Snl573036,
    '584724': Snl584724,
    '587800': Snl587800,
    '60143': Snl60143,
    '63069': Snl63069,
    '65205': Snl65205,
    '662369': Snl662369,
    '663245': Snl663245,
    '667757': Snl667757,
    '672537': Snl672537,
    '682563': Snl682563,
    '698144': Snl698144,
    '703767': Snl703767,
    '739560': Snl739560,
    '764030': Snl764030,
    '773470': Snl773470,
    '777366': Snl777366,
    '780263': Snl780263,
    '808260': Snl808260,
    '814074': Snl814074,
    '836843': Snl836843,
    '839255': Snl839255,
    '845573': Snl845573,
    '856243': Snl856243,
    '86675': Snl86675,
    '871769': Snl871769,
    '874845': Snl874845,
    '881478': Snl881478,
    '884303': Snl884303,
    '901358': Snl901358,
    '933966': Snl933966,
    '936462': Snl936462,
    '961576': Snl961576,
    '996260': Snl996260,
};

const SnlRouter = () => {
    const { snlno } = useParams();
    const location = useLocation();
    const Component = snlComponents[snlno];

    // Tracking refs
    const maxScrollRef = useRef(0);
    const sessionIdRef = useRef(null);
    const intervalRef = useRef(null);

    // Initialize/Retrieve Session ID
    useEffect(() => {
        let sid = sessionStorage.getItem('sessionId');
        if (!sid) {
            sid = crypto.randomUUID();
            sessionStorage.setItem('sessionId', sid);
        }
        sessionIdRef.current = sid;
    }, []);

    // Activity Tracking Logic
    useEffect(() => {
        if (!Component) return;

        // Reset tracking vars for new route
        maxScrollRef.current = 0;

        const handleScroll = () => {
            const scrollHeight = document.documentElement.scrollHeight;
            const clientHeight = window.innerHeight;
            const scrollTop = window.scrollY;

            // Calculate scroll percentage (bottom position relative to total height)
            const currentScroll = Math.min(100, Math.round(((scrollTop + clientHeight) / scrollHeight) * 100));

            if (currentScroll > maxScrollRef.current) {
                maxScrollRef.current = currentScroll;
            }
        };

        const sendTrackingData = () => {
            const payload = {
                sessionId: sessionIdRef.current,
                url: window.location.href,
                payload: {
                    maxScroll: maxScrollRef.current,
                    viewport: `${window.innerWidth}x${window.innerHeight}`
                }
            };

            axios.post(serverConfig.api_base_url + "statum_user_activity", payload)
                .then((response) => {
                    if (response.data.status === 200) {
                        // Success - Silent
                    }
                })
                .catch((err) => console.log("tracking error is", err));
        };

        // Event listeners
        window.addEventListener('scroll', handleScroll);

        // Initial heartbeat
        sendTrackingData();

        // Throttled heartbeat every 15 seconds
        intervalRef.current = setInterval(sendTrackingData, 15000);

        // Cleanup
        return () => {
            window.removeEventListener('scroll', handleScroll);
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [location.pathname, Component]);

    // Redirect to 404 if the snlno is not valid
    if (!Component) {
        return <Navigate to="/404" replace />;
    }

    return (
        <Suspense fallback={<div style={{ padding: '20px' }}>Loading Component...</div>}>
            <Component />
        </Suspense>
    );
};

export default SnlRouter;
